/**
 * React Flow's d3-zoom calls selection.interrupt (from d3-transition).
 * Duplicate d3-selection copies in the bundle often leave interrupt missing — patch it.
 */
import { selection } from 'd3-selection';

try {
  // eslint-disable-next-line global-require
  require('d3-transition');
} catch {
  /* optional */
}

if (typeof selection.prototype.interrupt !== 'function') {
  selection.prototype.interrupt = function interrupt() {
    return this;
  };
}
